export const APP_NAME = "Commutr";

export const STATIC_TITLES: Record<string, string> = {
  "/login": "Login",
  "/forgot-password": "Forgot Password",
  "/reset-password": "Reset Password",
  "/signup": "Sign Up",
  "/unauthorized": "Unauthorized",
  "/dashboard": "Dashboard", // safety net if "Dashboard" isn't itself a menu row
};
